<template>
  <div class="node-reg">
    <div class="left-section">
      <div v-html="$t('superNode.beSuperNode')"></div>
    </div>
    <div class="right-section">
      <dna-button class="btn" @click="onRegisterClick">
        <p v-html="$t('superNode.registerSuperNode')"></p>
      </dna-button>
      <div>
        <div
          class="btn-fee"
          v-if="!isLifetimeAccount"
        >{{$t("asset.upgradeFee")}}{{formatToken(upgradeFee)}}</div>
        <div class="btn-fee">{{$t("asset.registerWitnessFee")}}{{formatToken(registerFee)}}</div>
      </div>
    </div>

    <dna-spin v-if="isLoading"></dna-spin>
    <!-- 更新签名公钥 -->
    <dna-modal
      :isShow="isSignKeyShow"
      :isHeaderShow="false"
      @closed="isSignKeyShow = false"
      :width="625"
    >
      <div class="update-modal-content small">
        <div class="title">{{$t("superNode.signKeyTitle")}}</div>
        <textarea
          ref="signKeyRef"
          class="signkey-input"
          @input="onSignKeyInput"
          placeholder
          v-model="signKey"
        ></textarea>
      </div>
      <div class="update-modal-footer small">
        <dna-button :type="'cancel'" @click="onSignKeyCancelClick">{{$t('global.cancel')}}</dna-button>
        <dna-button @click="onSignKeyConfirmClick">{{$t('global.confirm')}}</dna-button>
      </div>
    </dna-modal>

    <!-- 输入密码 -->
    <dna-password-modal
      :isShow="isPasswordModalShow"
      @closed="isPasswordModalShow = false"
      @confirm="onPasswordConfirm"
    ></dna-password-modal>
  </div>
</template>

<script>
import wsSubscribe from "@/req/wsSubscribe.js";
import tx from "@/req/tx.js";
import wallet from "@/util/wallet.js";
import UTIL from "@/util/util.js";
import ERROR from "@/util/error.js";
import DATA from "@/data/data.js";
export default {
  data() {
    return {
      isLoading: false,
      isPasswordModalShow: false,
      isSignKeyShow: false,
      signKey: "",
      upgradeFee: 0,
      registerFee: 0,
      isLifetimeAccount: false
    };
  },
  async mounted() {
    await this.loadFee();
  },
  methods: {
    onRegisterClick() {
      let that = this;
      that.isSignKeyShow = true;
    },

    async loadFee() {
      let that = this;
      let feeResults = await wsSubscribe.wsFetchOperationFees([
        "account_upgrade",
        "witness_create"
      ]);

      console.log(feeResults);
      if (feeResults.length) {
        that.upgradeFee = feeResults[0].membership_lifetime_fee;
        that.registerFee = feeResults[1].fee;
      }

      let accounts = await wsSubscribe.wsFetchBtsGetAccountDetail(that.address);
      if (accounts && accounts.length) {
        let account = accounts[0];
        that.isLifetimeAccount = account.id == account.lifetime_referrer;
      }
    },
    onSignKeyInput(e) {
      let value = e.target.value;
      this.signKey = value;
    },
    // 确认Signkey
    onSignKeyConfirmClick() {
      let that = this;
      that.isSignKeyShow = false;
      let isPublicKey = wallet.isPublicKey(that.signKey);
      if (!isPublicKey) {
        let msg = that.$t("superNode.incorrectPublicKey");
        that.$Message.error({
          background: true,
          duration: 5,
          content: msg
        });
        return;
      }
      that.isPasswordModalShow = true;
    },
    // 取消Signkey
    onSignKeyCancelClick() {
      this.isSignKeyShow = false;
    },
    async onPasswordConfirm(pwd) {
      let that = this;
      try {
        that.isPasswordModalShow = false;
        let url = "";
        let signingKey = that.signKey;
        let isPublicKey = wallet.isPublicKey(signingKey);
        if (!isPublicKey) {
          let msg = that.$t("superNode.incorrectPublicKey");
          that.$Message.error({
            background: true,
            duration: 5,
            content: msg
          });
          return;
        }

        let userInfo = that.$store.state.userInfo;
        let mnemonic = UTIL.decryptKey(userInfo.key, pwd);
        if (!mnemonic) {
          that.isLoading = false;
          that.$Message.error({
            background: true,
            duration: 5,
            content: that.$t("global.passwordError")
          });
          return;
        }
        //console.log("mnemonic:" + mnemonic);
        that.isLoading = true;
        if (that.net == "bts") {
          // BTS网络下，查询该ID对应信息
          let walletInfo = wallet.getAccountInfo(mnemonic, that.net);
          //console.log(walletInfo.privateKey.toWif());
          let registerResult = await tx.registerOrUpdateWitness(
            walletInfo.privateKey,
            userInfo.name,
            signingKey,
            url
          );
          let txId =
            registerResult && registerResult.length ? registerResult[0].id : "";
          that.$Message.success({
            background: true,
            duration: 3,
            content: that.$t("asset.registerSuccess") + " " + txId
          });
        }
        if (that.net == "sub") {
          // SUB网络，直接存储
        }
        this.isLoading = false;
        //this.$router.push("/supernode/conf").catch(e => {});
        this.$emit("onRegisterSuccess"); // 传值父组件
        return;
      } catch (err) {
        that.isLoading = false;
        let msg =
          ERROR.getCustomMessage(err, that.$t.bind(that)) ||
          that.$t("global.networkError");
        that.$Message.error({
          background: true,
          duration: 5,
          content: msg
        });
        //TODO:仅用于暂演示
        //TODO:需要获取费率
        //this.$emit("onRegisterSuccess"); // 传值父组件
        // that.$Message.error({
        //   background: true,
        //   duration: 5,
        //   content: that.$t("global.networkError")
        // });
      }
    },
    formatToken(val) {
      return UTIL.formatToken(val, [], 4); //
    }
  },
  computed: {
    net() {
      return this.$store.state.net;
    },
    address() {
      return (
        this.$store.state.userInfo.name || this.$store.state.userInfo.address
      );
    }
  }
};
</script>

<style lang="less" scoped>
@import url("./SuperNodeRegister.less");
</style>